import { color, palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

const RecipeImagePlaceholder: FC<ViewProps> = (props) => (
  <View style={[styles.placeholder, props.style]}>
    <FontAwesomeIcon
      icon={['fad', 'salad']}
      color={color.primary}
      secondaryColor={palette.Secondary_blue}
      size={80}
    />
  </View>
);

// Styles
const styles = StyleSheet.create({
  placeholder: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: color.secondary,
  },
});

export default RecipeImagePlaceholder;
